import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
} from '@material-ui/core';

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { NuevaEvolucionAfiliado } from '../../../../../actions/hce/hceActions';

export const ModalIngresoEvolucion = (props) => {
  const dispatch = useDispatch();
  const [descripcion, setDescripcion] = useState(null);
  const [error, setError] = useState(false);
  const { hce, problema } = props;

  const onChangeTextAreaHandler = (e) => {
    const hayError = e?.target?.value?.length === 0;
    setError(hayError);
    if (!hayError) setDescripcion(e.target.value);
  };

  const onSubmitHandler = () => {
    if (descripcion !== null) {
      const datos = {
        idProblema: problema.id,
        evolucion: descripcion,
        idEfectorRed: hce.idEfector,
        idAgenda: hce.idAgenda,
        teleconsulta: hce.idTipoTurnoSol ? 1 : 0
      };
      dispatch(NuevaEvolucionAfiliado(datos));
      props.close();
    }
  };

  return (
    <Dialog fullWidth maxWidth="md" open={props.open} onClose={props.close}>
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ paddingLeft: 16 }}
            >
              <TextValidator
                fullWidth
                variant="outlined"
                multiline
                rows={4}
                label="Ingrese Evolucion"
                name="Evolcion"
                value={descripcion}
                validators={['required']}
                errorMessages={['Este campo es requerido']}
                disabled={false}
                onChange={onChangeTextAreaHandler}
                error={error}
                helperText={error && 'Este campo es requerido'}
              />
            </Grid>
          </Grid>
          <div
            style={{
              margin: '1rem 0',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-evenly',
            }}
          >
            <Button variant="contained" color="primary" onClick={props.close}>
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={props.disabled}
              color="primary"
            >
              Guardar
            </Button>
          </div>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};
